import React, { useState, useEffect, useCallback } from 'react'
import { ArrowRight, X, ChevronLeft, ChevronRight, Star, CheckCircle } from 'lucide-react'

const ResultsStrip = () => {
    const [galleryOpen, setGalleryOpen] = useState(false)
    const [selectedImage, setSelectedImage] = useState(null)
    const [activeFilter, setActiveFilter] = useState('all')

    // 6 curated showcase results
    const showcaseResults = [
        { id: 1, image: "/mobile-optimized/gallery/eric-transformations-mobile/1.webp", fallback: "/gallery/eric-transformations/1.png", technique: "SAPHORÏ®", title: "Reconstruction frontale complète", grafts: "3200 greffons", timeline: "18 mois", featured: true },
        { id: 20, image: "/mobile-optimized/gallery/eric-transformations-mobile/20.webp", fallback: "/gallery/eric-transformations/20.png", technique: "SAPHORÏ®", title: "Transformation globale", grafts: "3800 greffons", timeline: "20 mois", featured: true },
        { id: 5, image: "/mobile-optimized/gallery/eric-transformations-mobile/5.webp", fallback: "/gallery/eric-transformations/5.png", technique: "SAPHORÏ®", title: "Restauration vertex", grafts: "2800 greffons", timeline: "15 mois" },
        { id: 3, image: "/mobile-optimized/gallery/eric-transformations-mobile/3.webp", fallback: "/gallery/eric-transformations/3.png", technique: "CHOÏ", title: "Ligne frontale précise", grafts: "2200 greffons", timeline: "12 mois" },
        { id: 18, image: "/mobile-optimized/gallery/eric-transformations-mobile/18.webp", fallback: "/gallery/eric-transformations/18.png", technique: "CHOÏ", title: "Reconstruction globale", grafts: "3400 greffons", timeline: "17 mois" },
    ]

    // Full gallery (all 25)
    const allResults = [
        { id: 1, technique: "SAPHORÏ®", title: "Reconstruction Frontale Complète", description: "3200 greffons - Densité maximale et ligne frontale indétectable.", age: "34 ans", timeline: "18 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/1.webp", fallback: "/gallery/eric-transformations/1.png", category: "frontal", featured: true },
        { id: 2, technique: "SAPHORÏ®", title: "Reconstruction Frontale Naturelle", description: "2600 greffons - Résultat ultra-naturel.", age: "31 ans", timeline: "14 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/2.webp", fallback: "/gallery/eric-transformations/2.png", category: "frontal" },
        { id: 5, technique: "SAPHORÏ®", title: "Restauration Vertex Sophistiquée", description: "2800 greffons - Couverture vertex complète.", age: "41 ans", timeline: "15 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/5.webp", fallback: "/gallery/eric-transformations/5.png", category: "vertex" },
        { id: 7, technique: "SAPHORÏ®", title: "Restauration Vertex Premium", description: "3000 greffons - Densité exceptionnelle.", age: "45 ans", timeline: "16 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/7.webp", fallback: "/gallery/eric-transformations/7.png", category: "vertex" },
        { id: 12, technique: "SAPHORÏ®", title: "Densification Frontale Elite", description: "2400 greffons - Renforcement ciblé.", age: "29 ans", timeline: "12 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/12.webp", fallback: "/gallery/eric-transformations/12.png", category: "frontal" },
        { id: 15, technique: "SAPHORÏ®", title: "Densification Complète", description: "2900 greffons - Résultat harmonieux.", age: "36 ans", timeline: "18 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/15.webp", fallback: "/gallery/eric-transformations/15.png", category: "global" },
        { id: 20, technique: "SAPHORÏ®", title: "Transformation Globale", description: "3800 greffons - Résultat spectaculaire.", age: "38 ans", timeline: "20 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/20.webp", fallback: "/gallery/eric-transformations/20.png", category: "global", featured: true },
        { id: 22, technique: "SAPHORÏ®", title: "Reconstruction Sophistiquée", description: "2700 greffons - Précision maximale.", age: "33 ans", timeline: "13 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/22.webp", fallback: "/gallery/eric-transformations/22.png", category: "frontal" },
        { id: 3, technique: "CHOÏ", title: "Ligne Frontale Précise", description: "2200 greffons - Angle naturel parfait.", age: "27 ans", timeline: "12 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/3.webp", fallback: "/gallery/eric-transformations/3.png", category: "frontal" },
        { id: 6, technique: "CHOÏ", title: "Restauration Vertex Précise", description: "2600 greffons - Implantation directe.", age: "35 ans", timeline: "15 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/6.webp", fallback: "/gallery/eric-transformations/6.png", category: "vertex" },
        { id: 8, technique: "CHOÏ", title: "Restauration Vertex CHOÏ", description: "2500 greffons - Technique experte.", age: "39 ans", timeline: "14 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/8.webp", fallback: "/gallery/eric-transformations/8.png", category: "vertex" },
        { id: 11, technique: "CHOÏ", title: "Densification Experte", description: "2800 greffons - Résultat dense.", age: "37 ans", timeline: "16 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/11.webp", fallback: "/gallery/eric-transformations/11.png", category: "global" },
        { id: 13, technique: "CHOÏ", title: "Densification Frontale CHOÏ", description: "2100 greffons - Résultat subtil.", age: "32 ans", timeline: "11 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/13.webp", fallback: "/gallery/eric-transformations/13.png", category: "frontal" },
        { id: 16, technique: "CHOÏ", title: "Reconstruction Elite", description: "2300 greffons - Technique de pointe.", age: "30 ans", timeline: "12 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/16.webp", fallback: "/gallery/eric-transformations/16.png", category: "frontal" },
        { id: 18, technique: "CHOÏ", title: "Reconstruction Globale CHOÏ", description: "3400 greffons - Transformation complète.", age: "42 ans", timeline: "17 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/18.webp", fallback: "/gallery/eric-transformations/18.png", category: "global" },
        { id: 24, technique: "CHOÏ", title: "Ligne Frontale Naturelle", description: "1900 greffons - Finesse maximale.", age: "28 ans", timeline: "10 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/24.webp", fallback: "/gallery/eric-transformations/24.png", category: "frontal" },
        { id: 4, technique: "SAPHIR", title: "Ligne Frontale SAPHIR", description: "2000 greffons - Incisions ultra-fines.", age: "26 ans", timeline: "10 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/4.webp", fallback: "/gallery/eric-transformations/4.png", category: "frontal" },
        { id: 9, technique: "SAPHIR", title: "Restauration Vertex SAPHIR", description: "2400 greffons - Cicatrisation rapide.", age: "40 ans", timeline: "14 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/9.webp", fallback: "/gallery/eric-transformations/9.png", category: "vertex" },
        { id: 10, technique: "SAPHIR", title: "Restauration Vertex Raffinée", description: "2300 greffons - Résultat harmonieux.", age: "38 ans", timeline: "13 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/10.webp", fallback: "/gallery/eric-transformations/10.png", category: "vertex" },
        { id: 14, technique: "SAPHIR", title: "Densification SAPHIR", description: "1800 greffons - Approche douce.", age: "34 ans", timeline: "12 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/14.webp", fallback: "/gallery/eric-transformations/14.png", category: "frontal" },
        { id: 17, technique: "SAPHIR", title: "Densification Elite SAPHIR", description: "2700 greffons - Technique optimisée.", age: "36 ans", timeline: "15 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/17.webp", fallback: "/gallery/eric-transformations/17.png", category: "global" },
        { id: 19, technique: "SAPHIR", title: "Reconstruction Globale", description: "3100 greffons - Couverture totale.", age: "43 ans", timeline: "18 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/19.webp", fallback: "/gallery/eric-transformations/19.png", category: "global" },
        { id: 21, technique: "SAPHIR", title: "Reconstruction Frontale Expert", description: "2100 greffons - Résultat naturel.", age: "31 ans", timeline: "11 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/21.webp", fallback: "/gallery/eric-transformations/21.png", category: "frontal" },
        { id: 23, technique: "SAPHIR", title: "Transformation Complète", description: "2900 greffons - Métamorphose totale.", age: "44 ans", timeline: "17 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/23.webp", fallback: "/gallery/eric-transformations/23.png", category: "global" },
        { id: 25, technique: "SAPHIR", title: "Ligne Frontale Naturelle", description: "1700 greffons - Résultat discret.", age: "25 ans", timeline: "9 mois", image: "/mobile-optimized/gallery/eric-transformations-mobile/25.webp", fallback: "/gallery/eric-transformations/25.png", category: "frontal" },
    ]

    const filters = [
        { id: 'all', label: 'Tous' },
        { id: 'SAPHORÏ®', label: 'SAPHORÏ®' },
        { id: 'CHOÏ', label: 'CHOÏ' },
        { id: 'SAPHIR', label: 'SAPHIR' },
    ]

    const filteredResults = activeFilter === 'all'
        ? allResults
        : allResults.filter(r => r.technique === activeFilter)

    // Lock body scroll when overlay is open
    useEffect(() => {
        if (galleryOpen || selectedImage) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
        return () => { document.body.style.overflow = '' }
    }, [galleryOpen, selectedImage])

    // Keyboard nav
    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Escape') {
            if (selectedImage) setSelectedImage(null)
            else if (galleryOpen) setGalleryOpen(false)
        }
    }, [selectedImage, galleryOpen])

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [handleKeyDown])

    const openGallery = () => {
        setGalleryOpen(true)
        setActiveFilter('all')
    }

    return (
        <>
            {/* ═══════════════════════════════════════════ */}
            {/* HOMEPAGE SHOWCASE SECTION                    */}
            {/* ═══════════════════════════════════════════ */}
            <section id="resultats" className="results-showcase">
                <div className="container">
                    {/* Header */}
                    <div className="showcase-header">
                        <div className="showcase-header-text">
                            <p className="showcase-label">Résultats Vérifiés</p>
                            <h2 className="showcase-title">+2000 Transformations Réussies</h2>
                            <p className="showcase-subtitle">
                                Chaque résultat est unique. Découvrez les transformations réalisées
                                avec nos techniques exclusives.
                            </p>
                        </div>
                        <div className="showcase-stats">
                            <div className="showcase-stat">
                                <span className="showcase-stat-number">98%</span>
                                <span className="showcase-stat-label">Satisfaction</span>
                            </div>
                            <div className="showcase-stat-divider" />
                            <div className="showcase-stat">
                                <span className="showcase-stat-number">3</span>
                                <span className="showcase-stat-label">Techniques</span>
                            </div>
                            <div className="showcase-stat-divider" />
                            <div className="showcase-stat">
                                <span className="showcase-stat-number">15+</span>
                                <span className="showcase-stat-label">Ans d'expertise</span>
                            </div>
                        </div>
                    </div>

                    {/* Grid */}
                    <div className="showcase-grid">
                        {showcaseResults.map((result, index) => (
                            <div
                                key={result.id}
                                className={`showcase-card ${index === 0 ? 'showcase-card-large' : ''}`}
                                onClick={openGallery}
                            >
                                <div className="showcase-card-image">
                                    <img
                                        src={result.image}
                                        alt={result.title}
                                        loading={index < 3 ? "eager" : "lazy"}
                                        onError={(e) => { e.target.src = result.fallback }}
                                    />
                                    <div className="showcase-card-overlay">
                                        <span className="showcase-card-technique">{result.technique}</span>
                                        {result.featured && (
                                            <span className="showcase-card-featured">
                                                <Star size={12} fill="currentColor" /> Top
                                            </span>
                                        )}
                                    </div>
                                    <div className="showcase-card-info">
                                        <h3>{result.title}</h3>
                                        <div className="showcase-card-meta">
                                            <span>{result.grafts}</span>
                                            <span className="showcase-card-timeline">{result.timeline}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* CTA */}
                    <div className="showcase-cta-wrapper">
                        <button className="showcase-cta" onClick={openGallery}>
                            Découvrir plus de résultats
                            <ArrowRight size={18} />
                        </button>
                    </div>
                </div>
            </section>

            {/* ═══════════════════════════════════════════ */}
            {/* FULL-SCREEN GALLERY OVERLAY                  */}
            {/* ═══════════════════════════════════════════ */}
            {galleryOpen && (
                <div className="gallery-overlay" onClick={() => { setGalleryOpen(false); setSelectedImage(null); }}>
                    <div className="gallery-panel" onClick={e => e.stopPropagation()}>
                        {/* Gallery Header */}
                        <div className="gallery-header">
                            <div className="gallery-header-left">
                                <h2 className="gallery-title">Nos Résultats</h2>
                                <span className="gallery-count">{filteredResults.length} transformations</span>
                            </div>
                            <div className="gallery-filters">
                                {filters.map(f => (
                                    <button
                                        key={f.id}
                                        className={`gallery-filter-btn ${activeFilter === f.id ? 'active' : ''}`}
                                        onClick={() => setActiveFilter(f.id)}
                                    >
                                        {f.label}
                                    </button>
                                ))}
                            </div>
                            <button className="gallery-close" onClick={() => { setGalleryOpen(false); setSelectedImage(null); }}>
                                <X size={24} />
                            </button>
                        </div>

                        {/* Gallery Grid */}
                        <div className="gallery-scroll">
                            <div className="gallery-grid">
                                {filteredResults.map((item) => (
                                    <div
                                        key={item.id}
                                        className="gallery-card"
                                        onClick={() => setSelectedImage(item)}
                                    >
                                        <div className="gallery-card-image">
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                loading="lazy"
                                                onError={(e) => { e.target.src = item.fallback }}
                                            />
                                            <span className="gallery-card-technique">{item.technique}</span>
                                        </div>
                                        <div className="gallery-card-body">
                                            <h4>{item.title}</h4>
                                            <p>{item.age} &middot; {item.timeline}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════ */}
            {/* IMAGE DETAIL LIGHTBOX                        */}
            {/* ═══════════════════════════════════════════ */}
            {selectedImage && (
                <div className="lightbox-overlay" onClick={() => setSelectedImage(null)}>
                    <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={() => setSelectedImage(null)}>
                            <X size={24} />
                        </button>
                        <div className="lightbox-image">
                            <img
                                src={selectedImage.image}
                                alt={selectedImage.title}
                                onError={(e) => { e.target.src = selectedImage.fallback }}
                            />
                        </div>
                        <div className="lightbox-details">
                            <span className="lightbox-technique">{selectedImage.technique}</span>
                            <h3 className="lightbox-title">{selectedImage.title}</h3>
                            <p className="lightbox-description">{selectedImage.description}</p>
                            <div className="lightbox-meta">
                                <div className="lightbox-meta-item">
                                    <span className="lightbox-meta-label">Âge</span>
                                    <span className="lightbox-meta-value">{selectedImage.age}</span>
                                </div>
                                <div className="lightbox-meta-item">
                                    <span className="lightbox-meta-label">Résultat</span>
                                    <span className="lightbox-meta-value">{selectedImage.timeline}</span>
                                </div>
                            </div>
                            <div className="lightbox-guarantee">
                                <CheckCircle size={18} />
                                Résultat garanti à vie
                            </div>
                            <button
                                className="lightbox-cta"
                                onClick={() => {
                                    setSelectedImage(null)
                                    setGalleryOpen(false)
                                    if (window.openBenChat) window.openBenChat()
                                }}
                            >
                                Je veux ce résultat
                                <ArrowRight size={18} />
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                /* ══════════════════════════════════════ */
                /* SHOWCASE SECTION                       */
                /* ══════════════════════════════════════ */
                .results-showcase {
                    padding: 80px 0;
                    background: #FAFBFF;
                    position: relative;
                }

                .showcase-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    margin-bottom: 50px;
                    gap: 40px;
                }

                .showcase-label {
                    font-size: 0.8rem;
                    font-weight: 700;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: #8B6F47;
                    margin-bottom: 12px;
                }

                .showcase-title {
                    font-family: var(--font-heading);
                    font-size: clamp(2rem, 4vw, 2.75rem);
                    color: #2F2F84;
                    font-weight: 600;
                    line-height: 1.15;
                    margin-bottom: 12px;
                }

                .showcase-subtitle {
                    font-size: 1.05rem;
                    color: #666;
                    line-height: 1.6;
                    max-width: 480px;
                }

                .showcase-stats {
                    display: flex;
                    align-items: center;
                    gap: 24px;
                    flex-shrink: 0;
                }

                .showcase-stat {
                    text-align: center;
                }

                .showcase-stat-number {
                    display: block;
                    font-size: 1.8rem;
                    font-weight: 700;
                    color: #2F2F84;
                    line-height: 1;
                }

                .showcase-stat-label {
                    display: block;
                    font-size: 0.75rem;
                    color: #888;
                    font-weight: 500;
                    margin-top: 4px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .showcase-stat-divider {
                    width: 1px;
                    height: 40px;
                    background: #E0E0E0;
                }

                /* Grid: first card spans 2 rows */
                .showcase-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    grid-template-rows: auto auto;
                    gap: 20px;
                    margin-bottom: 40px;
                }

                .showcase-card {
                    cursor: pointer;
                    border-radius: 16px;
                    overflow: hidden;
                    position: relative;
                    transition: transform 0.4s ease, box-shadow 0.4s ease;
                }

                .showcase-card:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 20px 60px rgba(47, 47, 132, 0.15);
                }

                .showcase-card-large {
                    grid-row: span 2;
                }

                .showcase-card-image {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    min-height: 280px;
                    overflow: hidden;
                    background: #f0f0f0;
                }

                .showcase-card-large .showcase-card-image {
                    min-height: 100%;
                }

                .showcase-card-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    transition: transform 0.6s ease;
                }

                .showcase-card:hover .showcase-card-image img {
                    transform: scale(1.06);
                }

                .showcase-card-overlay {
                    position: absolute;
                    top: 16px;
                    left: 16px;
                    right: 16px;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    z-index: 2;
                }

                .showcase-card-technique {
                    background: rgba(255,255,255,0.92);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    padding: 5px 14px;
                    border-radius: 20px;
                    font-size: 0.72rem;
                    font-weight: 700;
                    color: #2F2F84;
                    letter-spacing: 0.3px;
                }

                .showcase-card-featured {
                    background: rgba(255, 215, 0, 0.95);
                    padding: 5px 12px;
                    border-radius: 20px;
                    font-size: 0.7rem;
                    font-weight: 700;
                    color: #333;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .showcase-card-info {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    padding: 60px 20px 20px;
                    background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%);
                    z-index: 2;
                }

                .showcase-card-info h3 {
                    color: white;
                    font-size: 1rem;
                    font-weight: 600;
                    margin-bottom: 6px;
                }

                .showcase-card-meta {
                    display: flex;
                    justify-content: space-between;
                    font-size: 0.82rem;
                    color: rgba(255,255,255,0.8);
                }

                .showcase-card-timeline {
                    color: #D4AF37;
                    font-weight: 600;
                }

                .showcase-cta-wrapper {
                    text-align: center;
                }

                .showcase-cta {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    padding: 16px 36px;
                    background: #2F2F84;
                    color: white;
                    border: none;
                    border-radius: 50px;
                    font-size: 1rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .showcase-cta:hover {
                    background: #1e1e5f;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 30px rgba(47, 47, 132, 0.3);
                    gap: 14px;
                }

                /* ══════════════════════════════════════ */
                /* GALLERY OVERLAY                        */
                /* ══════════════════════════════════════ */
                .gallery-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.6);
                    backdrop-filter: blur(4px);
                    -webkit-backdrop-filter: blur(4px);
                    z-index: 1100;
                    display: flex;
                    justify-content: center;
                    animation: fadeIn 0.3s ease;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from { opacity: 0; transform: translateY(40px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .gallery-panel {
                    width: 100%;
                    max-width: 1200px;
                    height: 100vh;
                    background: #FAFBFF;
                    display: flex;
                    flex-direction: column;
                    animation: slideUp 0.35s ease;
                }

                .gallery-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 24px 40px;
                    border-bottom: 1px solid #E8EAF6;
                    background: white;
                    flex-shrink: 0;
                    gap: 20px;
                }

                .gallery-header-left {
                    display: flex;
                    align-items: baseline;
                    gap: 16px;
                }

                .gallery-title {
                    font-family: var(--font-heading);
                    font-size: 1.5rem;
                    color: #2F2F84;
                    font-weight: 600;
                    margin: 0;
                }

                .gallery-count {
                    font-size: 0.85rem;
                    color: #888;
                }

                .gallery-filters {
                    display: flex;
                    gap: 8px;
                }

                .gallery-filter-btn {
                    padding: 8px 18px;
                    border-radius: 20px;
                    border: 1.5px solid #E0E0E0;
                    background: white;
                    color: #666;
                    font-size: 0.82rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .gallery-filter-btn:hover {
                    border-color: #2F2F84;
                    color: #2F2F84;
                }

                .gallery-filter-btn.active {
                    background: #2F2F84;
                    border-color: #2F2F84;
                    color: white;
                }

                .gallery-close {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    border: none;
                    background: #F0F2FF;
                    color: #2F2F84;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    flex-shrink: 0;
                }

                .gallery-close:hover {
                    background: #2F2F84;
                    color: white;
                }

                .gallery-scroll {
                    flex: 1;
                    overflow-y: auto;
                    padding: 16px 40px 30px;
                }

                .gallery-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
                    gap: 20px;
                }

                .gallery-card {
                    background: white;
                    border-radius: 14px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
                }

                .gallery-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 40px rgba(47, 47, 132, 0.12);
                }

                .gallery-card-image {
                    position: relative;
                    height: 220px;
                    overflow: hidden;
                }

                .gallery-card-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.4s ease;
                }

                .gallery-card:hover .gallery-card-image img {
                    transform: scale(1.05);
                }

                .gallery-card-technique {
                    position: absolute;
                    top: 12px;
                    left: 12px;
                    background: rgba(255,255,255,0.92);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    padding: 4px 12px;
                    border-radius: 16px;
                    font-size: 0.7rem;
                    font-weight: 700;
                    color: #2F2F84;
                }

                .gallery-card-body {
                    padding: 16px;
                }

                .gallery-card-body h4 {
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #2F2F84;
                    margin: 0 0 4px;
                }

                .gallery-card-body p {
                    font-size: 0.8rem;
                    color: #888;
                    margin: 0;
                }

                /* ══════════════════════════════════════ */
                /* LIGHTBOX                               */
                /* ══════════════════════════════════════ */
                .lightbox-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.85);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    z-index: 1200;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 40px;
                    animation: fadeIn 0.25s ease;
                }

                .lightbox-content {
                    background: white;
                    border-radius: 20px;
                    max-width: 860px;
                    width: 100%;
                    max-height: 85vh;
                    overflow: hidden;
                    display: grid;
                    grid-template-columns: 1.1fr 1fr;
                    position: relative;
                    animation: slideUp 0.3s ease;
                }

                .lightbox-close {
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    z-index: 10;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    border: none;
                    background: rgba(255,255,255,0.9);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    color: #333;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                }

                .lightbox-close:hover {
                    background: #2F2F84;
                    color: white;
                }

                .lightbox-image {
                    background: #f5f5f5;
                    display: flex;
                    align-items: center;
                }

                .lightbox-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                .lightbox-details {
                    padding: 40px 32px;
                    display: flex;
                    flex-direction: column;
                    overflow-y: auto;
                }

                .lightbox-technique {
                    display: inline-block;
                    background: #F0F2FF;
                    color: #2F2F84;
                    padding: 6px 16px;
                    border-radius: 6px;
                    font-size: 0.8rem;
                    font-weight: 700;
                    align-self: flex-start;
                    margin-bottom: 16px;
                }

                .lightbox-title {
                    font-size: 1.6rem;
                    color: #2F2F84;
                    font-family: var(--font-heading);
                    margin: 0 0 12px;
                    font-weight: 600;
                }

                .lightbox-description {
                    color: #666;
                    line-height: 1.6;
                    margin: 0 0 24px;
                    font-size: 0.95rem;
                }

                .lightbox-meta {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 16px;
                    background: #FAFBFF;
                    padding: 16px 20px;
                    border-radius: 12px;
                    margin-bottom: 24px;
                }

                .lightbox-meta-label {
                    display: block;
                    font-size: 0.72rem;
                    color: #8B6F47;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 2px;
                }

                .lightbox-meta-value {
                    display: block;
                    font-size: 1.05rem;
                    color: #2F2F84;
                    font-weight: 600;
                }

                .lightbox-guarantee {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    color: #28a745;
                    font-weight: 600;
                    font-size: 0.9rem;
                    margin-bottom: 20px;
                }

                .lightbox-cta {
                    margin-top: auto;
                    width: 100%;
                    padding: 16px;
                    background: #2F2F84;
                    color: white;
                    border: none;
                    border-radius: 12px;
                    font-weight: 600;
                    font-size: 1rem;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    transition: all 0.2s ease;
                }

                .lightbox-cta:hover {
                    background: #1e1e5f;
                    transform: translateY(-1px);
                    box-shadow: 0 6px 20px rgba(47, 47, 132, 0.3);
                }

                /* ══════════════════════════════════════ */
                /* RESPONSIVE                             */
                /* ══════════════════════════════════════ */
                @media (max-width: 1024px) {
                    .showcase-header {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .showcase-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .showcase-card-large {
                        grid-row: span 1;
                    }

                    .gallery-header {
                        flex-wrap: wrap;
                        padding: 20px 24px;
                    }

                    .gallery-scroll {
                        padding: 24px;
                    }
                }

                @media (max-width: 768px) {
                    .results-showcase {
                        padding: 60px 0;
                    }

                    .showcase-stats {
                        gap: 16px;
                    }

                    .showcase-stat-number {
                        font-size: 1.4rem;
                    }

                    .showcase-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 12px;
                    }

                    .showcase-card-image {
                        min-height: 200px;
                    }

                    .showcase-card-info h3 {
                        font-size: 0.85rem;
                    }

                    .showcase-card-meta {
                        font-size: 0.75rem;
                    }

                    .gallery-panel {
                        max-width: 100%;
                    }

                    .gallery-header {
                        padding: 16px 20px;
                    }

                    .gallery-filters {
                        order: 3;
                        width: 100%;
                        overflow-x: auto;
                        flex-wrap: nowrap;
                    }

                    .gallery-scroll {
                        padding: 20px;
                    }

                    .gallery-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 12px;
                    }

                    .gallery-card-image {
                        height: 160px;
                    }

                    .lightbox-overlay {
                        padding: 0;
                    }

                    .lightbox-content {
                        grid-template-columns: 1fr;
                        max-height: 100vh;
                        border-radius: 0;
                        height: 100vh;
                        overflow-y: auto;
                    }

                    .lightbox-image {
                        height: 300px;
                    }

                    .lightbox-details {
                        padding: 24px 20px;
                    }
                }

                @media (max-width: 480px) {
                    .showcase-grid {
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                    }

                    .showcase-card:last-child:nth-child(odd) {
                        grid-column: span 2;
                    }

                    .showcase-card-image {
                        min-height: 180px;
                    }

                    .gallery-grid {
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                    }

                    .gallery-card-image {
                        height: 140px;
                    }

                    .gallery-card-body {
                        padding: 12px;
                    }

                    .gallery-card-body h4 {
                        font-size: 0.8rem;
                    }
                }
            `}</style>
        </>
    )
}

export default ResultsStrip
